import React, { useCallback, useEffect, useState } from 'react';
import TabPanel, { Item as TabItem } from "devextreme-react/tab-panel";
import { useNavigate } from 'react-router-dom';
import DataGrid, { Column, Paging, Scrolling, SearchPanel } from 'devextreme-react/data-grid';
import useApi from '../../hooks/useApi';
import Guid from '../../models/Guid';
import '../base/form-list-base.css';
import './gestion-historique-entrees.css';

interface IHistoriqueEntree {
  idEnregistrementEntete: Guid;
  nom: string;
  date: Date;
  membre: string;
}

export default function GestionHistoriqueEntrees() {
   const navigate = useNavigate();
  const { getData, isLoading } = useApi<IHistoriqueEntree[]>();
  const [entrees, setEntrees] = useState<IHistoriqueEntree[]>([]);

  const renderTabTitle = () => (
   <span className="historique-entrees-tab-title">
     Historique des entrées
     <i
       className="dx-icon dx-icon-close historique-entrees-tab-close"
       onClick={(e) => {
         e.stopPropagation();
         navigate(-1);
       }}
     />
   </span>
 );
 
  const loadEntrees = useCallback(async () => {
    const data = await getData({
      customPath: "EnregistrementEntete/historique",
      returnOnly: true,
    });
    setEntrees(Array.isArray(data) ? data : []);
  }, [getData]);

  useEffect(() => {
    loadEntrees();
  }, [loadEntrees]);

  return (
    <div className="base-form-content gestion-historique-entrees">
      <div className="form-left-content">
        <TabPanel
          height="100%"
          width="100%"
          showNavButtons={false}
          itemTitleRender={renderTabTitle}
        >
          <TabItem title="Historique des entrées">
            <DataGrid
              dataSource={entrees}
              keyExpr="idEnregistrementEntete"
              showBorders={true}
              showColumnLines={true}
              showRowLines={true}
              allowColumnResizing={true}
              columnAutoWidth={false}
              height="100%"
              noDataText={isLoading ? "Chargement..." : "Aucun historique d'entrées"}
            >
              <SearchPanel visible={true} width={240} />
              <Scrolling mode="virtual" />
              <Paging enabled={false} />
              <Column dataField="nom" caption="Nom" dataType="string" width="50%" />
              <Column dataField="date" caption="Date" dataType="date" format="yyyy-MM-dd" width="30%" />
              <Column dataField="membre" caption="Membre" dataType="string" width="20%" />
            </DataGrid>
          </TabItem>
        </TabPanel>
      </div>
    </div>
  );
}
